import Report from './report.svelte';
import Login from './login.svelte';

const report = new Report({
	target: document.body
});

export default report;